import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AbstractCycleDateWindowService } from '../abstraction/abstract.cycle-date-window.service';
import { CurrentCycleWindow } from '../../interfaces/current-cycle-window/current-cycle-window';

@Injectable({
  providedIn: 'root',
})
export class RtpCycleDateService extends AbstractCycleDateWindowService {
  controller = `/manager/rtp/cycledate`;
  urlCurrentCycleDateWindow = `${environment.apiUrl}${this.controller}/get`;
  constructor(private http: HttpClient) {
    super();
  }

  getCurrentCycleDateWindow(): Promise<CurrentCycleWindow | undefined> {
    return this.http.get<CurrentCycleWindow>(`${this.urlCurrentCycleDateWindow}`).toPromise();
  }
}
